/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap} from "gsap";
import {DDay} from "../../DDay";
import {BlitzKriegGameMode} from "../../server/BlitzKriegGameMode";
import {DDayGameConfig} from "../../DDayGameConfig";
import {BlitzKriegSound} from "../../sound/BlitzKriegSound";
import {BlitzKriegSymbolState} from "../../symbol/DDaySymbolConfig";
import {TimelineLite} from "gsap";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin(): boolean {
        const data = DDay.model.parsedGameData;
        return ((data.mode != BlitzKriegGameMode.FREESPIN && data.mode != BlitzKriegGameMode.SUPER_FREESPIN) && data.nextMode === BlitzKriegGameMode.FS_PICK);
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = gsap.timeline({
            onComplete: () => {
                BlitzKriegSound.fadeAndStopSound({name: BlitzKriegSound.MAIN_GAME_MUSIC, to: 0, duration: 100});
                BlitzKriegSound.fadeAndStopSound({name: "mainXbet", to: 0, duration: 100});
            }
        });
        for (let reelId = 0; reelId < DDayGameConfig.REELS_NUM; reelId++) {
            for (let symId = 0; symId < DDayGameConfig.REELS_SYM_COUNT[reelId]; symId++) {
                tl.add(DDay.commonService.dimFireOverlay(true, reelId, symId), 0);
                tl.add(DDay.commonService.dimBulletOverlay(true, reelId, symId), 0);
            }
        }
        let delay: number = 0;
        DDay.model.parsedGameData.scatterPositions!.forEach((symId, reelId) => {
            if (symId > -1) {
                const symbol = DDay.reels[reelId].getSymbol(symId);
                const symTl = gsap.timeline();
                symTl.add(symbol.getStateAnimation(BlitzKriegSymbolState.WIN, {}, {}));
                tl.add([symTl, () => {
                    BlitzKriegSound.playTrack({name: "scatterCount"});
                }], delay);
                delay += 0.3;
            }
        });
        tl.to(this, {duration: 0.1}); // Add this line because the DDay server didn't give scatterPositions and the empty tl doesn't continue the promise chain.
        await Promise.resolve(tl);
        DDay.freespinIntro.show(() => {
        });
    }
}
